const Booker: any[] = [
  { id: 1, name: '김민수', avatar: 'avatar1' },
  { id: 2, name: '이서준', avatar: 'avatar2' },
  { id: 3, name: '박지훈', avatar: 'avatar3' },
  { id: 4, name: '최예진', avatar: 'avatar4' },
  { id: 5, name: '장하준', avatar: 'avatar5' },
  { id: 6, name: '윤서영', avatar: 'avatar6' },
  { id: 7, name: '정우진', avatar: 'avatar7' },
  { id: 8, name: '한지민', avatar: 'avatar8' },
  { id: 9, name: '오은서', avatar: 'avatar9' },
  { id: 10, name: '서지호', avatar: 'avatar10' },
];

export default Booker;
